export const MILLIS_SECONDS_IN_A_DAY = 86400000;
